import { API_CONFIG, fetchApi, fetchApiNullable } from "./api";

const BASE_URL = API_CONFIG.POOL_SERVICE;

export type ImageType = "POOL_IMAGE" | "USER_PROFILE" | "TECHNICIAN_PROFILE";
export type ImageEntityType = "POOL" | "USER" | "TECHNICIAN";

export interface EntityImage {
  id: number;
  url: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  imageType: ImageType;
  entityId: number;
  entityType: ImageEntityType;
  isPrimary: boolean;
  createdAt: string;
}

interface UploadImageRequest {
  file: File;
  imageType: ImageType;
  entityId: number;
  entityType: ImageEntityType;
}

export const imageApi = {
  upload: async ({
    file,
    imageType,
    entityId,
    entityType,
  }: UploadImageRequest) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("imageType", imageType);
    formData.append("entityId", String(entityId));
    formData.append("entityType", entityType);

    return fetchApi<EntityImage>(`${BASE_URL}/images/upload`, {
      method: "POST",
      body: formData,
    });
  },

  getById: (id: number) => fetchApi<EntityImage>(`${BASE_URL}/images/${id}`),

  getByEntity: (entityId: number, entityType: ImageEntityType) =>
    fetchApi<EntityImage[]>(
      `${BASE_URL}/images/entity/${entityId}?entityType=${entityType}`,
    ),

  getPrimaryByEntity: async (entityId: number, entityType: ImageEntityType) => {
    const image = await fetchApiNullable<EntityImage>(
      `${BASE_URL}/images/entity/${entityId}/primary?entityType=${entityType}`,
    );

    return image;
  },

  setPrimary: (id: number) =>
    fetchApi<EntityImage>(`${BASE_URL}/images/${id}/primary`, {
      method: "PUT",
    }),

  delete: (id: number) =>
    fetchApi<void>(`${BASE_URL}/images/${id}`, {
      method: "DELETE",
    }),
};
